// Helper utilities for group settings modal data shaping.
export const resolveGroupDeviceIds = (group) =>
  Array.isArray(group?.devices) ? group.devices : [];

export const resolveGroupDevices = (connectedDevices, group) => {
  if (!Array.isArray(connectedDevices) || !group) return [];
  const idSet = new Set(resolveGroupDeviceIds(group));
  return connectedDevices.filter((device) => idSet.has(device.id));
};

export const getGroupDeviceTypeInfo = (devices) => {
  const typeSet = new Set(devices.map((device) => device?.device_type).filter(Boolean));
  const types = [...typeSet];
  return {
    types,
    isUniform: typeSet.size <= 1,
    deviceType: typeSet.size === 1 ? types[0] : null,
  };
};
